export default __webpack_public_path__ + "ea399620854c6a67a957dbf0e1be9f2c.png";